import React, {SVGProps} from 'react';
import { Icons } from './assets';

// To use this component you need just to add appropriate svg
// file to assets folder when your start-https-no-chunks script is started
// Icons type will be automatically updated and your file name will be automatically transformed to camelCase.
// Then just go to the place where you want to use icon, import Icon and add icon property.
// It will suggest icon you have just added

interface Props {
    icon: Icons;
    className?: string;
    onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
    alt?: string;
}

const Icon: React.FC<Props & SVGProps<any>> = ({ icon, className, onClick, ...props }) => {
    const { default: IconPath } = require(`./assets/${icon}.svg`);

    return <IconPath className={`custom-icon ${className ? className : ''}`} onClick={onClick} {...props} />;
};

export default Icon;
